import React from "react";
import { Tag, Space, Button, Popconfirm } from "antd";
import { EditOutlined, DeleteOutlined } from "@ant-design/icons";
import DataTable from "../../../components/DataTable";

const getRoleColor = (roleName) => {
  const role = (roleName || "").toLowerCase();
  if (role === "admin") return "#49627a";
  if (role === "manager") return "#2b751d";
  if (role === "creator") return "#e29b45";
  if (role === "guest") return "#bd565d";
  return "default";
};

export default function SkeyeingestUsersTable({
  data,
  loading,
  page,
  pageSize,
  onPageChange,
  onEditUser,
  onDeleteUser,
  isRoleUser,
}) {
  const columns = [
    {
      title: "Name",
      dataIndex: "name",
      key: "name",
      width: "25%",
      sorter: (a, b) => (a.name || "").localeCompare(b.name || ""),
    },
    {
      title: "Roles",
      dataIndex: "roles",
      key: "roles",
      width: "30%",
      render: (roles) => (
        <Space size={[0, 4]} wrap>
          {(roles || []).map((role, idx) => (
            <Tag color={getRoleColor(role)} key={idx}>
              {role}
            </Tag>
          ))}
        </Space>
      ),
    },
    {
      title: "Groups",
      dataIndex: "groups",
      key: "groups",
      width: "30%",
      render: (groups) => (groups || []).join(", "),
    },
  ];

  if (!isRoleUser) {
    columns.push({
      title: "Actions",
      key: "actions",
      width: "15%",
      render: (_, record) => (
        <Space size="middle">
          <Button
            type="text"
            icon={<EditOutlined />}
            onClick={() => onEditUser(record)}
            style={{ color: "#e29b45" }}
            title="Edit User"
          />
          <Popconfirm
            title="Delete User"
            description={`Are you sure you want to delete "${record.name}"?`}
            onConfirm={() => onDeleteUser(record.name)}
            okText="Yes"
            cancelText="No"
            okButtonProps={{ danger: true }}
          >
            <Button
              type="text"
              danger
              icon={<DeleteOutlined />}
              title="Delete User"
            />
          </Popconfirm>
        </Space>
      ),
    });
  }

  return (
    <DataTable
      rowKey="name"
      columns={columns}
      data={data}
      loading={loading}
      page={page}
      pageSize={pageSize}
      onPageChange={onPageChange}
    />
  );
}
